import React from 'react';
import { useIntl } from 'react-intl';
import clsx from 'clsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy } from '@fortawesome/pro-light-svg-icons/faCopy';
import { faCheck } from '@fortawesome/pro-light-svg-icons/faCheck';
import { TypedMemo } from '../../../common/types';
import { SMLButton } from '../../../music24/components/primitives/SMLButton';
import { aiAssistantsMessages as messages } from './aiAssistantsMessages';
import { useCopyFlag } from './useCopyFlag';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the AI assistants tab; each part uses its own slice of it */
import styles from './aiAssistants.module.scss';
/* eslint-enable css-modules/no-unused-class */

/** design: ai-assistants a1 `.ai-url` — the connector URL on one line, with its copy button. */
const AiConnectorUrlComponent: React.FC<{ url: string }> = ({ url }) => {
  const intl = useIntl();
  const { copied, copyText } = useCopyFlag(url);
  return (
    <div className={styles.field}>
      <div className={styles.label}>{intl.formatMessage(messages.urlLabel)}</div>
      <div className={styles.url}>
        <code className={styles.urlText} title={url} data-testid="ai-connector-url">
          {url}
        </code>
        <SMLButton
          className={clsx(styles.copy, copied && styles.copyOk)}
          icon={<FontAwesomeIcon icon={copied ? faCheck : faCopy} />}
          onClick={copyText}
          ariaLabel={intl.formatMessage(messages.copyLabel)}
        >
          {intl.formatMessage(copied ? messages.copied : messages.copy)}
        </SMLButton>
      </div>
    </div>
  );
};

export const AiConnectorUrl = TypedMemo(AiConnectorUrlComponent);
